import React from 'react';

export default function GoogleBusinessBanner({ onConnect, onDismiss }) {
  return (
    <div style={styles.banner}>
      <div style={styles.icon} aria-hidden>🔔</div>
      <div style={styles.body}>
        <div style={styles.title}>Connectez Google Business</div>
        <div style={styles.subtitle}>Permet de répondre aux avis depuis l'app</div>
        <div style={styles.actions}>
          <button
            type="button"
            style={styles.connectBtn}
            onClick={() => {
              if (typeof onConnect === 'function') onConnect();
              else console.log('[GoogleBusinessBanner] tap Connecter — OAuth flow Session 5');
            }}
          >
            Connecter
          </button>
          <button
            type="button"
            style={styles.laterBtn}
            onClick={() => {
              if (typeof onDismiss === 'function') onDismiss();
              else console.log('[GoogleBusinessBanner] tap Plus tard');
            }}
          >
            Plus tard
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    background: '#FFF4D6',
    borderRadius: 16,
    padding: 16,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
  },
  icon: {
    fontSize: 22,
    lineHeight: 1,
    marginTop: 2,
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  title: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  subtitle: {
    fontSize: 13,
    color: '#6B6B6B',
    marginBottom: 8,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  connectBtn: {
    background: '#E8502A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 999,
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  laterBtn: {
    background: 'transparent',
    color: '#6B6B6B',
    border: 'none',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
    padding: 4,
  },
};
